export const buildCollectionsEndpoint = ({ search = '', sort = 'updated_desc', page = 1 } = {}) => {
    const params = new URLSearchParams({
        paginated: '1',
        sort,
        page: String(page),
    });
    const normalizedSearch = search.trim();

    if (normalizedSearch) {
        params.set('search', normalizedSearch);
    }

    return `/carts?${params.toString()}`;
};

export const mergeCollectionPages = (existingCollections, incomingCollections) => {
    const collectionsById = new Map();

    [...existingCollections, ...incomingCollections].forEach((collection) => {
        if (!collectionsById.has(collection.id)) {
            collectionsById.set(collection.id, collection);
        }
    });

    return Array.from(collectionsById.values());
};
